import React from "react";
import {
  마켓봄피쳐_목록,
  type 마켓봄피쳐,
  마켓봄피쳐_기본,
} from "./데이터/마켓봄피쳐";
import { BoldableTextList, BoldableTextMultiline } from "./BoldableText";
import Image from "next/image";

import styles from "./마켓봄_장점_Mobile2.module.css";

type 섹션Props = {
  마켓봄피쳐: 마켓봄피쳐;
};

const 섹션3_Row = ({ 마켓봄피쳐 }: 섹션Props) => {
  const {
    제목: { 단점, 장점 },
    설명,
    이미지,
  } = 마켓봄피쳐_목록()[마켓봄피쳐];

  return (
    <div className={styles["row"]}>
      <div className={styles["rowContent"]}>
        <dl className={styles["textContent"]}>
          <dt className={styles["desc-title"]}>
            <BoldableTextList list={단점} />
            <br />
            <span className="fc1">
              <BoldableTextList list={장점} />
            </span>
          </dt>
          <dd className={styles["desc-desc"]}>
            <BoldableTextMultiline list={설명} align="center" />
          </dd>
        </dl>

        <Image
          src={이미지}
          alt=""
          width="280"
          height="226"
          loading="eager"
          priority
          style={{
            flex: 1,
            objectFit: "contain",
            height: "226px",
          }}
        />
      </div>
    </div>
  );
};

type 섹션3_Row_Group_Props = {
  마켓봄피쳐_그룹: readonly 마켓봄피쳐[];
};

const 섹션3_Row_Group = ({ 마켓봄피쳐_그룹 }: 섹션3_Row_Group_Props) => {
  return (
    <div className={styles["row-group"]}>
      {마켓봄피쳐_그룹.map((마켓봄피쳐) => (
        <섹션3_Row key={마켓봄피쳐} 마켓봄피쳐={마켓봄피쳐} />
      ))}
    </div>
  );
};

export type 마켓봄_장점_Props = {
  선택된_목록: readonly 마켓봄피쳐[];
};

const PrimaryHeader = () => {
  return (
    <h3 className={styles["primaryTitle"]}>
      <div className={styles["sub"]}>{"수발주 관리에 한계를 느끼셨나요?"}</div>
      <div className={styles["main"]}>
        {"마켓봄은 그 "}
        <span className={styles["highlight"]}>{"해결책"}</span>
        {"을"}
        <br />
        {"가지고 있습니다!"}
      </div>
    </h3>
  );
};

const MoreHeader = () => {
  return (
    <div className={styles["title"]}>
      {"이런 것도"}
      <br />
      {"해결할 수 있어요!"}
    </div>
  );
};

export const 마켓봄_장점_Mobile2 = ({ 선택된_목록 }: 마켓봄_장점_Props) => {
  const 선택되지_않은_목록 = 마켓봄피쳐_기본.filter(
    (x) => !선택된_목록.includes(x)
  );

  return (
    <div className={`section ${styles["section3"]}`}>
      {선택된_목록.length > 0 ? (
        <>
          <PrimaryHeader />
          <섹션3_Row_Group 마켓봄피쳐_그룹={선택된_목록} />
        </>
      ) : (
        <></>
      )}
      {선택된_목록.length > 0 ? <MoreHeader /> : <PrimaryHeader />}
      <섹션3_Row_Group 마켓봄피쳐_그룹={선택되지_않은_목록} />
    </div>
  );
};
